import * as Yup from "yup";
import { AppShape } from "@eave/shared/types/api";
import { ExpectedGrossMonthlyRentalIncomeFormValues } from "./shared";

export const expectedGrossMonthlyRentalIncomeValidationSchema = Yup.object().shape({
  expected_gross_monthly_rental_income: Yup.string().max(8, "Too big!"),
});

export const initialExpectedGrossMonthlyRentalIncomeFromApp = (
  app: AppShape,
): ExpectedGrossMonthlyRentalIncomeFormValues => ({
  expected_gross_monthly_rental_income: app?.expected_gross_monthly_rental_income,
});
